module.exports = __webpack_public_path__ + "media/images/countrysquared/er-4cbdd191f764edc9f4e1b3780137842d.svg";